import { useEffect, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import { FechaString, IFormato, IFormulario } from 'utils/models/interfaces';
import { IAltaFunciones } from 'utils/models/types';
import { useNavigate, useParams } from 'react-router-dom';
import { registroFunciones } from 'services/servicioPut';
import { useError } from 'services/ErrorContext';
import { CalendarMonthOutlined, DateRange } from '@mui/icons-material';
import { getAuthToken } from 'services/apiUtils';
import { fetchEspectaculoPorId } from 'utils/redux/features/espectaculoPorIdSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import { convertirFechasAISOString, agregarDuracionAFechas, formatoFechaHora } from 'utils/utilities';
import { theme } from 'theme/theme';
import { anchoMaxLogueado } from 'utils/constants';

interface IformFunciones {
  titulo: string;
  textoBoton: string;
}

const AltaFunciones = ({ titulo, textoBoton }: IformFunciones) => {
  const { id } = useParams();
  const { error, setError, clearError, loading, setLoading } = useError();
  const { espectaculo, loadingEspectaculo, errorEspectaculo } = useSelector((state: RootState) => state.espectaculo);
  const dispatch = useDispatch<AppDispatch>();
  const [mensajeExito, setMensajeExito] = useState('');
  const idEspectaculo = Number(id);
  const navigate = useNavigate();

  useEffect(() => {
    id && dispatch(fetchEspectaculoPorId(Number(id)));
  }, [id, dispatch]);

  const duracion = espectaculo && espectaculo.Funciones && espectaculo.Funciones[0]?.Duracion;

  const datosRegistroFunciones: IFormato<IAltaFunciones>[] = [
    {
      name: 'Duracion',
      label: 'Duración de la obra',
      inputType: 'number',
      adornment: 'minutos',
      disabled: !!duracion,
      defaultValue: duracion || 0,
    },
    { name: 'FechasObras', label: 'Seleccionar fecha', inputType: 'datepicker' },
  ];

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const { FechasObras, Duracion } = data;
    const fechasValidas = FechasObras?.filter(fecha => fecha !== '');

    const fechasInicio = convertirFechasAISOString(fechasValidas!);
    const fechasFin = agregarDuracionAFechas(fechasInicio, Duracion!);

    const fechas: FechaString[] = fechasInicio.map((fechaInicio, index) => ({
      Id: 0,
      FechaInicio: fechaInicio,
      FechaFin: fechasFin[index],
    }));

    const requestFunciones: IAltaFunciones = {
      EspectaculoId: idEspectaculo,
      Fechas: fechas,
    };

    try {
      getAuthToken();
      await registroFunciones(requestFunciones, setError, setLoading);
      setMensajeExito('¡Funciones registradas con éxito!');
    } catch (error) {
      console.error('Error de registro:', error);
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
    navigate(`/admin/espectaculos/${id}`);
  };

  const funciones = espectaculo?.Funciones?.map(funcion => new Date(funcion.Fecha.FechaInicio));

  return (
    <Box>
      {loadingEspectaculo ? (
        <Spinner />
      ) : errorEspectaculo ? (
        <NoResponse />
      ) : (
        <>
          <Box mx="auto" maxWidth={anchoMaxLogueado}>
            <Formulario
              campos={datosRegistroFunciones}
              titulo={titulo}
              textoBoton={textoBoton}
              onSubmit={handleSubmit}
              mensajeExito={mensajeExito}
              mensajeError={error}
              loading={loading}
              onVolver={handleVolver}
              iconoBoton={CalendarMonthOutlined}
              mensajeAlerta="Volver a la edición del espectáculo:"
              botonSecundario="Volver"
              onSecondaryClick={handleVolver}
            />
            {!mensajeExito && !!funciones?.length && (
              <Box maxWidth="600px" mx="auto">
                <Typography variant="h5" color={theme.palette.primary.main} pb={2}>
                  Funciones existentes
                </Typography>
                {funciones?.map((funcion, index) => (
                  <Chip
                    variant="outlined"
                    size="medium"
                    sx={{ mb: 1, mr: 1 }}
                    key={index}
                    label={funciones ? formatoFechaHora(funcion) : 'Sin funciones'}
                    icon={<DateRange sx={{ fontSize: '1rem' }} />}
                  />
                ))}
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default AltaFunciones;
